import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { BtnCellRenderer } from 'src/app/core/grid/btn-cell-render.component';
import { MatDialog } from '@angular/material/dialog';
import { AddTemplateTaskDialogComponent } from 'src/app/core/dialogs/add-template-task-dialog/add-template-task-dialog.component';
import { DeleteCategoryDialogComponent } from 'src/app/core/dialogs/delete-category-dialog/delete-category-dialog.component';
import { AddTemplateDialogComponent } from 'src/app/core/dialogs/add-template-dialog/add-template-dialog.component';
import { DeleteTemplateDialogComponent } from 'src/app/core/dialogs/delete-template-dialog/delete-template-dialog.component';
import { TemplatesService } from 'src/app/service/templates.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BoardsService } from 'src/app/service/boards.service';
import { UploadTemplateComponent } from './upload-template/upload-template.component';
import { TaskService } from '../../service/task.service';
import * as XLSX from 'xlsx';
import { ExcelService } from '../../service/excel.service';
import { Constants } from '../../constants';
import { FilterChangedEvent, GridOptions } from 'ag-grid-community';
export interface DialogData {
	performAction: string;
	placeholder_dday: string;
	placeholder_sequence: string;
	placeholder_taskid;
	placeholder_puser;
	placeholder_suser;
	placeholder_duetime;
	placeholder_region;
	page;
}
export interface deleteDialogData {
	template_id;
	template_name;
}
export interface deleteTemTaskData {
	template_task_id;
	template_task_name;
}
interface obj {
}
@Component({
	selector: 'app-templates',
	templateUrl: './templates.component.html',
	styleUrls: ['./templates.component.scss'],
	standalone: false,  // NOSONAR
})
export class TemplatesComponent implements OnInit {
	gridApi: any;
	gridColumnApi: any
	gridOptions: GridOptions;
	setPagination = 'true';
	defaultColDef;
	paginationPageSize: number = 30;
	currentPageNo: any;
	currentPageBoolean: boolean = false;
	totalPage: any;
	currentPageForTotalPage: any;
	isLastPageFound: any;
	successMessage = '';
	errorMessage = '';
	rowCount;
	columnDefs;
	rowData;
	icons;
	context: any;
	templateChosen = '';
	enableGrid: boolean = false;
	frameworkComponents;
	templates: any = [];
	tempData: any = [];
	tempData2: any = [];
	templateDesc: string;
	temp;
	temp2;
	userData;
	totalRecords = 0; // Replace with your actual total records count
	sRecord = 1;
	eRecord = 1;
	cPage = 1;
	tPage = 0;
	rpPage: any = 30;
	endRecord = 0;
	pgDropDown = [
		{ value: 5, selected: false },
		{ value: 10, selected: false },
		{ value: 20, selected: false },
		{ value: 30, selected: true },
		{ value: 50, selected: false },
	]
	constants = new Constants();
	@ViewChild('agGrid', { static: true }) agGrid
	dynamicHeight: number;
	workbook: XLSX.WorkBook;
	constructor(public dialog: MatDialog,
		private readonly templatesService: TemplatesService, private readonly ngxUiLoaderService: NgxUiLoaderService,
		private readonly boardService: BoardsService, private readonly taskService: TaskService, private readonly excelService: ExcelService) {
		this.dynamicHeight = 0.665 * (window.innerHeight);
		// booting up the ag grid
		this.context = {
			componentParent: this
		};
		this.columnDefs = [
			{
				headerName: "D-DAY", headerClass: "d_day", field: "dday", cellClass: "cell_dday", width: 120,
				suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true,
				floatingFilterComponentParams: { suppressFilterButton: true },
				filter: 'agTextColumnFilter',
				autoHeight: true
			},
			{
				headerName: "SEQUENCE", headerClass: "sequence", field: "sequence", cellClass: "cell_seq",
				width: 120, autoHeight: true
			},
			{
				headerName: "TASK", headerClass: "task", field: "task", cellClass: "cell_task",
				width: 370, autoHeight: true
			},
			{
				headerName: "DUE TIME", headerClass: "due_time", field: "duetime", cellClass: "cell_dueTime",
				width: 120, autoHeight: true
			},
			{
				headerName: "ASSIGNMENT", headerClass: "assignment", field: "assignment", cellClass: "cell_assignment"
				, width: 410, autoHeight: true,
				suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true,
				floatingFilterComponentParams: { suppressFilterButton: true },
				filter: 'agTextColumnFilter',
			},
			{
				headerName: "ACTIONS", field: "templates_action",
				width: 120, headerClass: "editdelete",
				cellRenderer: BtnCellRenderer,
				cellRendererParams: {
					clicked: function (_field: any, _act: any) {
						// do something
					}
				}
			}];
		this.frameworkComponents = {
			btnCellRenderer: BtnCellRenderer
		};
		this.icons = {
			sortUnSort: '<i class="fa fa-sort" style="font-weight:bold;color:black;"/>',
		};
		this.defaultColDef = {
			minWidth: 100,
			floatingFilter: true,
			wrapText: true
		};
	}
	sizeToFit() { this.gridApi.sizeColumnsToFit(); }
	goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }
	goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }
	goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }
	goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }
	onPageSizeChanged(event: any) { this.gridApi.paginationSetPageSize(Number(event.target.value)); this.updatePaginationDetails(); }
	getCurrentPage(): boolean {
		this.currentPageNo = this.agGrid?.api.paginationGetCurrentPage();
		if (this.currentPageNo == 0) { // NOSONAR
			this.currentPageBoolean = true;
		}
		else { this.currentPageBoolean = false; }
		return this.currentPageBoolean;
	}
	isLastPage(): boolean {
		this.totalPage = Number(this.agGrid?.api.paginationGetTotalPages());
		this.currentPageForTotalPage = Number(this.agGrid?.api.paginationGetCurrentPage()) + 1;
		if (this.totalPage == this.currentPageForTotalPage) { // NOSONAR
			this.isLastPageFound = true;
		}
		else {
			this.isLastPageFound = false;
		}
		return this.isLastPageFound;
	}
	rppChanged(event: any) {
		this.cPage = 1;
		this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
		this.updatePaginationDetails();
	}
	updatePaginationDetails() {
		if (this.gridApi) {
			this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
			this.tPage = this.gridApi.paginationGetTotalPages();
			this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
			this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
			this.totalRecords = this.gridApi.paginationGetRowCount();
			this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
		}
	}
	onGridReady(params: any) {
		this.gridApi = params.api;
		this.gridColumnApi = params.columnApi;
		this.gridApi.sizeColumnsToFit();
	}
	loadData() {
		this.ngxUiLoaderService.start("loader-01");
		//get templates list - api
		this.templates = [];
		this.templatesService.getTemplateDetails().subscribe(result => {
			console.info("calling getdetails");
			if (result?.length > 0) {
				//storing templates data in local
				localStorage.setItem('template-data', JSON.stringify(result));
				this.templates = result;
			}
			else {
				setTimeout(() => {
					this.successMessage = '';
					this.errorMessage = '';
				}, 6500);
			}
			this.ngxUiLoaderService.stop("loader-01");
		});
	}
	ngOnInit(): void {
		// clear contingency data
		sessionStorage.removeItem('contData');
		this.boardService.deleteContingenyList().subscribe(_result => {
			// contingency list deleted
		});
		this.loadData();
	}
	display() {
		console.info("chose", this.templateChosen);
		if (this.templateChosen) {
			this.enableGrid = true;
			this.templates.filter(x => x.templateID == this.templateChosen).forEach(e => { // NOSONAR
				this.templateDesc = e.description;
			});
			// get the tasks under templates
			this.ngxUiLoaderService.start("loader-01");
			//API Integration
			this.rowData = [];
			this.tempData = [];
			this.tempData2 = [];
			this.rowCount = 0;
			this.templatesService.getDetails(this.templateChosen).subscribe(result => {
				if (result?.length > 0) {
					this.tempData = result;
					let primaryUSER;
					let secondaryUSER;
					let regions;
					console.info("temp data", this.tempData);
					const taskTemp = JSON.parse(localStorage.getItem('task-data'));
					this.tempData.forEach(e => {
						const obj = {
							"sequence": undefined, "dday": undefined, "task": undefined, "assignment": undefined,
							"duetime": undefined, "templatetaskID": undefined, "taskId": undefined, "primaryuser": undefined,
							"secondaryuser": undefined, "regions": undefined
						};
						obj.templatetaskID = e.templatetaskID;
						obj.sequence = e.sequence;
						obj.dday = e.dday;
						obj.taskId = e.taskID;
						taskTemp.filter(x => x.taskID == e.taskID).forEach(element => { // NOSONAR
							obj.task = element.description;
						});
						let pri;
						let sec;
						//fetch from local-storage
						this.temp2 = localStorage.getItem('users-data');
						this.userData = JSON.parse(this.temp2);
						this.userData.filter(x => x.userPrincipalName == e.primaryuser).forEach(element => { // NOSONAR
							pri = element.firstName + ' ' + element.lastName;
						});
						this.userData.filter(x => x.userPrincipalName == e.secondaryuser).forEach(element => { // NOSONAR
							sec = element.firstName + ' ' + element.lastName;
						});
						if (e.primaryuser == null && e.secondaryuser == null && e.regions == null) { // NOSONAR
							obj.assignment = 'Template Creation';
						}
						else {
							if (e.primaryuser == null) { // NOSONAR
								primaryUSER = "No Primary User";
							}
							else {
								primaryUSER = pri;
							}
							if (e.secondaryuser == null) { // NOSONAR
								secondaryUSER = "No Secondary User";
							}
							else {
								secondaryUSER = sec;
							}
							if (e.regions == null) { // NOSONAR
								regions = "No Regions";
							}
							else {
								regions = e.regions;
							}
							obj.assignment = primaryUSER + ' / ' + secondaryUSER + ' / ' + regions;
						}
						obj.duetime = e.duetime.split(' ')[1].slice(0, -3);
						obj.primaryuser = e.primaryuser;
						obj.secondaryuser = e.secondaryuser;
						// get the region from here
						obj.regions = e.regions;
						this.tempData2.push(obj);
					});
					console.info("row data after", this.tempData2);
					this.rowData = this.tempData2;
					this.rowCount = this.rowData.length;
					if (this.rowData.length) {
						this.totalRecords = this.rowData.length;
						this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
						this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
						this.sRecord = 1
						this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
						if (this.cPage > this.tPage) {
							this.cPage = 1;
						}
					}
					this.ngxUiLoaderService.stop("loader-01");
				}
				else {
					setTimeout(() => {
						this.successMessage = '';
						this.errorMessage = '';
					}, 6500);
					this.ngxUiLoaderService.stop("loader-01");
				}
			});
		}
		else {
			this.enableGrid = false;
		}
	}
	// template tasks
	deleteTemplateRow(val) {
		let template_task_name;
		let id;
		this.rowData.filter(x => x.templatetaskID == val).forEach(e => { // NOSONAR
			id = e.templatetaskID;
			template_task_name = e.task;
		});
		console.info("id", id, template_task_name);
		const dialogRef = this.dialog.open(DeleteCategoryDialogComponent, {
			disableClose: true,
			width: '510px',
			data: { template_task_id: id, template_task_name: template_task_name, page: "template" }
		});
		dialogRef.afterClosed().subscribe(result => {
			console.info("data to be deleted:", result.data);
			const deletejson = {
				"templatetaskID": result.data
			}
			this.deleteRecords(deletejson);
		});
	}
	deleteRecords(dataArr) {
		this.ngxUiLoaderService.start("loader-01");
		this.templatesService.deleteTask(dataArr).subscribe(_result => {
			this.successMessage = 'Deleted Row(s) Successfully!';
			setTimeout(() => {
				this.successMessage = '';
				this.errorMessage = '';
			}, 6500);
			//fetch latest row data after deleting
			// this.loadData();
			this.display();
		});
	}
	editTemplateRow(val) {
		let template_task_name;
		let id;
		let dday;
		let duetime;
		let seq;
		let taskid;
		let puser;
		let suser;
		let region;
		this.rowData.filter(x => x.templatetaskID == val).forEach(e => { // NOSONAR
			id = e.templatetaskID;
			template_task_name = e.task;
			dday = e.dday;
			duetime = e.duetime;
			seq = e.sequence;
			taskid = e.taskId;
			puser = e.primaryuser;
			suser = e.secondaryuser;
			region = e.regions;
			console.info("row data")
		});
		const dialogRef = this.dialog.open(AddTemplateTaskDialogComponent, {
			disableClose: true,
			width: '700px',
			data: {
				performAction: 'EditCell', template_id: id, placeholder_task: template_task_name,
				placeholder_dday: dday, placeholder_duetime: duetime, placeholder_sequence: seq, page: 'Template',
				placeholder_taskid: taskid, placeholder_puser: puser, placeholder_suser: suser, placeholder_region: region
			}
		});
		dialogRef.afterClosed().subscribe(result => {
			const timeArray = [];
			if (result.event == 'EditCell') { // NOSONAR
				console.info("date result", result.data4);
				const a = result.data4.split(":");
				const currentTime = new Date()
				const month = currentTime.getMonth() + 1
				const day = currentTime.getDate()
				const year = currentTime.getFullYear()
				timeArray.push(year);
				timeArray.push(month);
				timeArray.push(day);
				timeArray.push(parseInt(a[0]));
				timeArray.push(parseInt(a[1]));
				//API Integration
				const dataArr = {
					"templatetaskID": id,
					"taskID": result.data1,
					"dday": result.data3,
					"duetime": timeArray,
					"sequence": result.data5,
					"primaryuser": result.data6,
					"secondaryuser": result.data7,
					"regions": result.data8
				};
				this.ngxUiLoaderService.start("loader-01");
				this.templatesService.editTask(dataArr).subscribe(_result => {
					this.successMessage = 'Task updated successfully!';
					setTimeout(() => {
						this.successMessage = '';
						this.errorMessage = '';
					}, 6500);
					//fetch latest row data after editing
					// this.loadData();
					this.display();
				});
			}
		});
	}
	addTask(): void {
		console.info("open dialog");
		const dialogRef = this.dialog.open(AddTemplateTaskDialogComponent, {
			disableClose: true,
			width: '700px',
			data: { performAction: 'AddCell', placeholder: '' }
		});
		dialogRef.afterClosed().subscribe(result => {
			const timeArray = [];
			if (result.event == 'AddCell') { // NOSONAR
				const a = result.data4.split(":");
				// Return today's date and time
				const currentTime = new Date()
				// returns the month (from 0 to 11)
				const month = currentTime.getMonth() + 1
				// returns the day of the month (from 1 to 31)
				const day = currentTime.getDate()
				// returns the year (four digits)
				const year = currentTime.getFullYear()
				console.info("yyyy", year, "month", month, "day", day, "time1", a[0], "time2", a[1]);
				timeArray.push(year);
				timeArray.push(month);
				timeArray.push(day);
				timeArray.push(parseInt(a[0]));
				timeArray.push(parseInt(a[1]));
				const dataArr = {
					"templatetaskID": null,
					"templateID": this.templateChosen,
					"taskID": result.data1,
					"dday": result.data3,
					"duetime": timeArray,
					"sequence": result.data5,
					"primaryuser": result.data6,
					"secondaryuser": result.data7,
					"regions": result.data8
				}
				console.info("data arr", dataArr);
				this.templatesService.addTask(dataArr).subscribe(result => {
					if (!result) {
						this.display();
						this.errorMessage = 'Task already exists!';
						setTimeout(() => {
							this.successMessage = '';
							this.errorMessage = '';
						}, 5000);
					}
					else if (result) {
						this.display();
						this.successMessage = 'Task added successfully!';
						setTimeout(() => {
							this.successMessage = '';
							this.errorMessage = '';
						}, 5000);
					}
				});
			}
		});
	}
	//templates
	addTemplate(): void {
		const dialogRef = this.dialog.open(AddTemplateDialogComponent, {
			disableClose: true,
			width: '401px',
			data: { performAction: 'AddCell', placeholder: '' }
		});
		dialogRef.afterClosed().subscribe(result => {
			console.info('The dialog was closed', result);
			const dataArr = {
				"templateID": null,
				"description": result.data
			}
			this.templatesService.addTemplate(dataArr).subscribe(result => {
				if (!result) {
					this.loadData();
					this.errorMessage = 'Template already exists!';
					setTimeout(() => {
						this.successMessage = '';
						this.errorMessage = '';
					}, 5000);
				}
				else if (result) {
					this.loadData();
					this.successMessage = 'Template added successfully!';
					setTimeout(() => {
						this.successMessage = '';
						this.errorMessage = '';
					}, 5000);
				}
			});
		});
	}
	deleteTemplate() {
		let template_name;
		let id;
		this.templates.filter(x => x.templateID == this.templateChosen).forEach(e => { // NOSONAR
			id = e.templateID;
			template_name = e.description;
		});
		const dialogRef = this.dialog.open(DeleteTemplateDialogComponent, {
			disableClose: true,
			width: '401px',
			data: { template_id: id, template_name: template_name }
		});
		dialogRef.afterClosed().subscribe(result => {
			console.info("data to be deleted:", result.data);
			const deletejson = {
				"templateID": result.data
			}
			this.deleteTemplateRecords(deletejson);
		});
	}
	deleteTemplateRecords(dataArr) {
		this.ngxUiLoaderService.start("loader-01");
		this.templatesService.deleteTemplate(dataArr).subscribe(_result => {
			this.successMessage = 'Deleted Template Successfully!';
			setTimeout(() => {
				this.successMessage = '';
				this.errorMessage = '';
			}, 6500);
			this.enableGrid = false;
			//fetch latest row data after deleting
			this.loadData();
		});
	}
	refreshData() {
		this.loadData();
		this.display();
	}
	uploadTemplate() {
		const dialog = this.dialog.open(UploadTemplateComponent, {
			disableClose: true,
			width: '800px',
			data: { "templateId": this.templateChosen }
		});
		dialog.afterClosed().subscribe(result => {
			if (result.status) {
				this.display();
			}
		});
	}
	onFilterChanged(params: FilterChangedEvent) {
		this.rowCount = params.api.getDisplayedRowCount();
	}
	downloadTemplate() {
		this.ngxUiLoaderService.start("loader-01");
		this.workbook = XLSX.utils.book_new();
		this.templatesService.downloadTemplate(this.templateChosen).subscribe(data => {
			if (data && data.length > 0) {
				const jsonData = [];
				data.forEach(ele => {
					jsonData.push({
						"Task ID": ele.taskID,
						"Task Name": ele.taskName,
						"D-Day": ele.dday,
						"Due Time": ele.due,
						"Sequence": ele.sequence,
						"Override Assignment": ele.overrideAssignment,
						"Primary User": ele.primaryUser,
						"Secondary User": ele.secondaryUser,
						"Regions": ele.region
					})
				})
				const worksheet = XLSX.utils.json_to_sheet(jsonData);
				XLSX.utils.book_append_sheet(this.workbook, worksheet, 'Templates');
			}
			this.taskService.getDetails().subscribe(data => {
				if (data && data.length > 0) {
					const jsonData = [];
					data.forEach(element => {
						jsonData.push({ "Task ID": element.taskID, "Description": element.description })
					});
					const worksheet = XLSX.utils.json_to_sheet(jsonData);
					XLSX.utils.book_append_sheet(this.workbook, worksheet, 'Tasks');
				}
				const worksheetInfo = XLSX.utils.json_to_sheet(this.constants.templateInfomation);
				XLSX.utils.book_append_sheet(this.workbook, worksheetInfo, 'Information');
				const excelBuffer: any = XLSX.write(this.workbook, { bookType: 'xlsx', type: 'array' });
				this.excelService.saveAsExcelFile(excelBuffer, 'Template Tasks');
				this.ngxUiLoaderService.stop("loader-01");
			})
		})
	}
}